if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 100));

      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        const button = mediaToSwitch.querySelector('button');
        button.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));

        // Add hover event for video autoplay
        button.addEventListener('mouseenter', () => {
          const mediaId = mediaToSwitch.dataset.target;
          const mediaElement = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
          const deferredMedia = mediaElement?.querySelector('.deferred-media');

          if (deferredMedia && !deferredMedia.getAttribute('loaded')) {
            // Preload video on hover
            this.setActiveMedia(mediaId, false);
          } else if (deferredMedia && deferredMedia.getAttribute('loaded')) {
            // If already loaded, ensure it plays muted
            const video = deferredMedia.querySelector('video, iframe');
            if (video && video.tagName === 'VIDEO') {
              video.muted = true;
              video.play().catch(() => {});
            }
          }
        });
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      console.log('🎬 onSlideChanged triggered', event.detail);
      const currentElement = event.detail.currentElement;
      const mediaId = currentElement.dataset.mediaId;

      console.log('📹 Current slide mediaId:', mediaId);

      // Update thumbnail highlight
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveThumbnail(thumbnail);

      // Mark current slide as active
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      currentElement.classList.add('is-active');

      // Play the media if it's a video
      console.log('🎯 Attempting to play media for slide');
      this.playActiveMedia(currentElement);
    }

    setActiveMedia(mediaId, prepend, skipScroll = false) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);

      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!skipScroll && (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked')) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      console.log('▶️ playActiveMedia called', activeItem);
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');

      if (!deferredMedia) {
        console.log('ℹ️ No deferred media found (probably an image)');
        return;
      }

      console.log('🎥 Deferred media found:', deferredMedia);
      const isLoaded = deferredMedia.getAttribute('loaded');
      const posterButton = deferredMedia.querySelector('[id^="Deferred-Poster-"]');

      console.log('📊 isLoaded:', isLoaded, 'posterButton:', posterButton);

      // Helper function to play video and hide poster
      const playVideo = (video, poster) => {
        if (!video) {
          console.log('❌ No video element to play');
          return;
        }

        console.log('🎬 Attempting to play video. ReadyState:', video.readyState, 'Video:', video);

        // Ensure iOS attributes are set (may already be set, but ensure)
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');

        video.play().then(() => {
          console.log('✅ Video playing successfully!');
          // Successfully started playing - hide poster
          if (poster) {
            console.log('🚫 Hiding poster button');
            poster.style.opacity = '0';
            poster.style.pointerEvents = 'none';
            setTimeout(() => {
              poster.style.display = 'none';
              console.log('✨ Poster button hidden completely');
            }, 300);
          }
        }).catch((error) => {
          console.warn('❌ Video autoplay failed:', error);
        });
      };

      // If video is already loaded, play immediately
      if (isLoaded) {
        console.log('⚡ Video already loaded, playing immediately');
        const video = deferredMedia.querySelector('video, iframe');
        console.log('🔍 Found video element:', video);
        if (video && video.tagName === 'VIDEO') {
          playVideo(video, posterButton);
        }
      } else {
        console.log('⏳ Video not loaded yet, clicking poster button to load');
        // Video not loaded yet - click poster button to load it
        if (posterButton) {
          console.log('👆 Clicking poster button');
          posterButton.click();

          // CRITICAL FOR iOS: Call play() IMMEDIATELY after user interaction (swipe)
          // Don't wait for events - iOS needs play() called within user gesture context
          const attemptImmediatePlay = () => {
            console.log('🔄 Checking for video element...');
            const video = deferredMedia.querySelector('video');

            if (video) {
              console.log('✓ Video element found! ReadyState:', video.readyState);

              // Set iOS attributes immediately
              video.muted = true;
              video.setAttribute('playsinline', '');
              video.setAttribute('webkit-playsinline', '');
              console.log('📱 iOS attributes set on video');

              // Load and play IMMEDIATELY - don't wait
              // This is crucial for iOS - must be within the user interaction context
              console.log('🎬 Attempting IMMEDIATE play (leveraging user swipe gesture)');

              // Load the video
              video.load();

              // Try to play immediately - iOS allows this if we're still in user gesture context
              video.play().then(() => {
                console.log('✅ Video playing successfully on FIRST attempt!');
                // Hide poster on successful play
                if (posterButton) {
                  console.log('🚫 Hiding poster button');
                  posterButton.style.opacity = '0';
                  posterButton.style.pointerEvents = 'none';
                  setTimeout(() => {
                    posterButton.style.display = 'none';
                    console.log('✨ Poster button hidden completely');
                  }, 300);
                }
              }).catch((error) => {
                console.warn('⚠️ Immediate play failed, waiting for video to load...', error);

                // If immediate play fails, wait for video to be ready
                const onCanPlay = () => {
                  console.log('🎉 canplay event fired! ReadyState:', video.readyState);
                  video.play().then(() => {
                    console.log('✅ Video playing after canplay event!');
                    if (posterButton) {
                      posterButton.style.opacity = '0';
                      posterButton.style.pointerEvents = 'none';
                      setTimeout(() => { posterButton.style.display = 'none'; }, 300);
                    }
                  }).catch(err => {
                    console.error('❌ Video autoplay completely failed:', err);
                  });
                  video.removeEventListener('canplay', onCanPlay);
                };

                video.addEventListener('canplay', onCanPlay, { once: true });
              });
            } else {
              console.log('⏳ Video element not in DOM yet, retrying in 50ms');
              setTimeout(attemptImmediatePlay, 50);
            }
          };

          // Call immediately - NO delay to stay within user gesture context
          console.log('🚀 Starting IMMEDIATE video check');
          attemptImmediatePlay();
        } else {
          console.log('❌ No poster button found');
        }
      }
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
